/*
 * @name:  
 * @description:  
 * @Author: Han bei 
 * @Date: 2018-10-15 15:46:36 
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2019-08-12 17:52:01
 *  
 *  text  value值
 *  index 索引
 *  type  需要组件类型   text、number、percent、input、inputNumber、inputPercent 不传值默认不显示文本
 *  name  行名称
 *  title 表头
 *  record 行数据 Object
 *  totolIndex  汇总的行、需要颜色区分
 *  sqlName  数据库名称 自定义表格需要
 *  onChange 利用父级函数更新数据
 */




import React, { Component } from 'react';
import Compared from "./Compared";
import { InputNumber, Input } from 'antd';

const { TextArea } = Input;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class TableText extends Component {
    render() {
        const { text = 0, index, type, name, onChange, totalIndex = [], warn, style } = this.props.data;
        const { title = [], record = {}, sqlName = "" } = this.props.data.compared || {};
        switch (type) {
            case 'input':
                return (
                    <div className={`table-padding table-color-number ${totalIndex.includes(index) ? 'table-color-footer' : ''} ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                        <Input
                            className="table_numInput"
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                onChange(name, value, index)
                            }}
                        />
                    </div>
                )
                break;
            case 'textArea':
                return (
                    <div className={`table-padding table-color-number ${totalIndex.includes(index) ? 'table-color-footer' : ''} ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                        <TextArea
                            autosize={{ minRows: 2 }}
                            className="table_numInput"
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                onChange(name, value, index)
                            }}
                        />
                    </div>
                )
                break;
            case 'number':
                if (this.props.data.compared) {
                    if (warn) {
                        return (
                            <Compared data={{ index, key: name, title, sqlName, name: record.name, type: "number" }} >
                                <div className={`table-padding  heightAuto heightAutoNum ${totalIndex.includes(index) ? 'table-color-footer' : ''} ${warn ? "table-text-warn" : ""} `} >
                                    <div style={{ color: "red" }}>
                                        {Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </div>
                            </Compared >
                        )
                    }
                    return (
                        <Compared data={{ index, key: name, title, sqlName, name: record.name, type: "number" }} >
                            <div className={`table-padding heightAuto heightAutoNum ${totalIndex.includes(index) ? 'table-color-footer' : ''}  `} >
                                <div>
                                    {Number(text || '0') < 0 ?
                                        <span style={{ color: "red" }}>
                                            ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                        </span>
                                        :
                                        Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                    }
                                </div>
                            </div>
                        </Compared >
                    )
                }

                if (warn) {
                    return (
                        <div className={`table-padding heightAuto heightAutoNum ${totalIndex.includes(index) ? 'table-color-footer' : ''} ${warn ? "table-text-warn" : ""}  `} >
                            <div style={{ color: "red" }}>
                                {Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        </div>
                    )
                }
                return (
                    <div className={`table-padding heightAuto heightAutoNum ${totalIndex.includes(index) ? 'table-color-footer' : ''}  `} >
                        <div>
                            {Number(text || '0') < 0 ?
                                <span style={{ color: "red" }}>
                                    ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                </span>
                                :
                                Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            }
                        </div>
                    </div>
                )
                break;
            case 'inputPercent':
                if (this.props.data.compared) {
                    return (
                        <Compared data={{ index, key: name, title, sqlName, name: record.name, type: "percent" }} >
                            <div className={`table-padding table-color-number ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                <InputNumber
                                    defaultValue={Number(text || "0") * 100 || ""}
                                    className="table_numInput"
                                    precision={1}
                                    formatter={value => `${value}%`}
                                    parser={value => value.replace('%', '')}
                                    onBlur={(e) => {
                                        let value = Number(e.target.value.replace(/%/g, '') || '0');
                                        value = Number(value.toFixed(1) / 100).toFixed(3);
                                        onChange(name, value, index)
                                    }}
                                />
                            </div>
                        </Compared >
                    )
                } else {
                    return (
                        <div className={`table-padding table-color-number ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                            <InputNumber
                                defaultValue={Number(text || "0") * 100 || ""}
                                className="table_numInput"
                                precision={1}
                                formatter={value => `${value}%`}
                                parser={value => value.replace('%', '')}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/%/g, '') || '0');
                                    value = Number(value.toFixed(1) / 100).toFixed(3);
                                    onChange(name, value, index)
                                }}
                            />
                        </div>
                    )
                }
                break;
            case 'inputNumber':
                if (this.props.data.compared) {
                    return (
                        <Compared data={{ index, key: name, title, sqlName, name: record.name, type: "number" }} >
                            <div className={`table-padding table-color-number ${warn ? "table-inputNumber-err" : ""} ${totalIndex.includes(index) ? 'table-color-footer' : ''}`}>
                                <InputNumber
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    precision={2}
                                    className="table_numInput"
                                    defaultValue={Number(text || "0") || ""}
                                    onBlur={(e) => {
                                        let value = Number(e.target.value.replace(/,/g, '') || '0');
                                        value = Number(value.toFixed(2));
                                        onChange(name, value, index)
                                    }}
                                />
                            </div>
                        </Compared >
                    )
                } else {
                    return (
                        <div className={`table-padding table-color-number ${totalIndex.includes(index) ? 'table-color-footer' : ''} ${warn ? "table-inputNumber-err" : ""}`} >
                            <InputNumber
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                precision={2}
                                className="table_numInput"
                                defaultValue={Number(text || "0") || ""}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                    value = Number(value.toFixed(2));
                                    onChange(name, value, index)
                                }}
                            />
                        </div>
                    )
                }
                break;
            case 'percent':
                // 百分比位数根据传值进行变动
                const num = (text.toString().split('.')[1] || "").length <= 3 ? 1 : (text.toString().split('.')[1] || "").length - 2;

                if (this.props.data.compared) {
                    return (
                        <Compared data={{ index, key: name, title, sqlName, name: record.name, type: "percent" }} >
                            <div className={`table-padding heightAuto heightAutoNum ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                <div>
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(num) + '%'})</span> : (text * 100).toFixed(num) + '%'}
                                </div>
                            </div>
                        </Compared >
                    )
                } else {
                    return (
                        <div className={`table-padding heightAuto heightAutoNum ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                            <div>
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(num) + '%'})</span> : (text * 100).toFixed(num) + '%'}
                            </div>
                        </div>
                    )
                }

                break;
            case 'text':
            case 'string':
            case 'textcenter':
                if (warn) {
                    return (
                        <div className={`table-padding heightAuto ${warn ? "table-text-warn" : ""}  `} style={{ textAlign: "left" }} >
                            <div style={{ color: "red", ...style }} dangerouslySetInnerHTML={{ __html: text || "-" }}></div>
                        </div>
                    )
                }
                return (
                    <div
                        className={`table-padding heightAuto ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}
                        style={{
                            textAlign: type === 'string' ? 'right' : type === 'textcenter' ? 'center' : "left",
                            justifyContent: type === 'string' ? 'flex-end' : type === 'textcenter' ? 'center' : "flex-start"
                        }}

                    >
                        <div
                            style={{
                                textAlign: type === 'string' ? 'right' : type === 'textcenter' ? 'center' : "left",
                                justifyContent: type === 'string' ? 'flex-end' : type === 'textcenter' ? 'center' : "flex-start",
                                ...style
                            }}
                            dangerouslySetInnerHTML={{ __html: text || "-" }}></div>
                    </div>
                )
                break;

            default:
                return (
                    <div className={`table-padding heightAuto ${totalIndex.includes(index) ? 'table-color-footer' : ''} `} style={{ textAlign: "center" }}>
                        <div>-</div>
                    </div>
                )
                break;
        }
    }
}

export default TableText;


// WEBPACK FOOTER //
// ./src/bp-views/table/TableText.js